import { AxiosError, AxiosInstance } from 'axios'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Opportunities API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const OpportunitiesApi: AxiosInstance = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.OPPORTUNITIES_API
  }
})

export const fetchSalesforceOpportunities = (accountId: string) => {
  return OpportunitiesApi.get(`/opportunities/by_accountId?accountId=${accountId}`).then(
    ({ data }) => data
  )
}
